// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"453":"844051c5","898":"c2c5a433"}[chunkId] + ".chunk.js";
};